'use client';

import { Suspense } from 'react';
import { AddressStep } from './steps/AddressStep';
import { ContactInfoStep } from './steps/ContactInfoStep';
import { SystemIssuesStep } from './steps/SystemIssuesStep';
import { PictureStep } from './steps/PictureStep';
import { SystemAgeStep } from './steps/SystemAgeStep';
import { MessageStep } from './steps/MessageStep';
import { UrgencyStep } from './steps/UrgencyStep';
import { BuyingDecisionStep } from './steps/BuyingDecisionStep';
import RepairFormController from './RepairFormController';
import { HeatSyncHandler } from '../HeatSyncHandler';

export interface RepairFormProps {
	testId?: string;
}

const RepairForm = (props: RepairFormProps) => {
	const { testId = 'RepairForm' } = props;

	return (
		<div data-testid={testId} className="flex grow flex-col">
			<Suspense>
				<RepairFormController>
					<HeatSyncHandler />
					<div className="hvac-container relative">
						{/* If you add a step remember to add the step component here. Order does not matter. */}
						<UrgencyStep />
						<AddressStep />
						<ContactInfoStep />
						<SystemIssuesStep />
						<PictureStep />
						<BuyingDecisionStep />
						<MessageStep />
						<SystemAgeStep />
					</div>
				</RepairFormController>
			</Suspense>
		</div>
	);
};

export default RepairForm;
